import React from "react";

const Auth_brand = () => {
  return (
    <>
      <aside class="auth-brand-panel" aria-hidden="true">
        <div class="brand-orb brand-orb-1"></div>
        <div class="brand-orb brand-orb-2"></div>
        <div class="brand-orb brand-orb-3"></div>
        <div class="brand-grid"></div>

        <div class="brand-bokeh" aria-hidden="true">
          <span class="bk bk-1"></span>
          <span class="bk bk-2"></span>
          <span class="bk bk-3"></span>
          <span class="bk bk-4"></span>
          <span class="bk bk-5"></span>
          <span class="bk bk-6"></span>
        </div>

        <div class="brand-content">
          <span class="brand-badge">
            <span class="brand-pulse"></span> Live operations
          </span>

          <h2 class="brand-title">One shipment. Complete visibility.</h2>
          <p class="brand-text">
            Follow every parcel from sender to doorstep with real-time tracking
            across the entire delivery journey.
          </p>

          {/* <!-- Shipment journey hero --> */}
          <div class="ship-hero" id="shipHero">
            {/* <!-- Sender / Receiver --> */}
            <div class="ship-card ship-sender">
              <span class="ship-avatar">S</span>
              <div class="ship-card-meta">
                <b>Sender</b>
                <span>Parcel pickup</span>
              </div>
            </div>
            <div class="ship-card ship-receiver">
              <span class="ship-avatar">R</span>
              <div class="ship-card-meta">
                <b>Receiver</b>
                <span>Doorstep delivery</span>
              </div>
            </div>

            <svg
              class="ship-svg"
              viewBox="0 0 720 460"
              preserveAspectRatio="xMidYMid meet"
              aria-hidden="true"
            >
              <defs>
                <filter
                  id="shipGlow"
                  x="-50%"
                  y="-50%"
                  width="200%"
                  height="200%"
                >
                  <feGaussianBlur stdDeviation="4" result="blur" />
                  <feMerge>
                    <feMergeNode in="blur" />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
                <filter
                  id="shipBlurSoft"
                  x="-50%"
                  y="-50%"
                  width="200%"
                  height="200%"
                >
                  <feGaussianBlur stdDeviation="9" />
                </filter>
                <linearGradient id="shipGrad" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0" stop-color="#60A5FA" />
                  <stop offset="1" stop-color="#A78BFA" />
                </linearGradient>
              </defs>

              {/* <!-- remaining (dim) route --> */}
              <path class="route-rem" />
              {/* <!-- soft glow under the completed route --> */}
              <path class="route-trail-glow" />
              {/* <!-- completed (glowing) route --> */}
              <path class="route-done" />

              {/* <!-- checkpoints (JS) --> */}
              <g id="checkpoints"></g>

              {/* <!-- hub nodes (JS) --> */}
              <g class="ship-hub" id="hubOrigin"></g>
              <g class="ship-hub" id="hubDest"></g>

              {/* <!-- vehicles --> */}
              <g class="vehicle" id="vehicleTruck">
                <g class="vt-body">
                  <path d="M3 16V7a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v9" />
                  <path d="M3 16h13" />
                  <path d="M16 16v-5h2.5l2.5 3.5V16" />
                </g>
                <g class="vt-wheels">
                  <g class="vt-wheel">
                    <circle cx="6.5" cy="18" r="2.3" />
                    <path d="M6.5 16.3v3.4M4.9 18h3.2" />
                  </g>
                  <g class="vt-wheel">
                    <circle cx="16.5" cy="18" r="2.3" />
                    <path d="M16.5 16.3v3.4M14.9 18h3.2" />
                  </g>
                </g>
              </g>
              <g class="vehicle" id="vehiclePlane">
                <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
              </g>

              {/* <!-- comet trail --> */}
              <g id="pkgTrail"></g>

              {/* <!-- package --> */}
              <g id="pkg">
                <ellipse class="pkg-shadow" cx="0" cy="9" rx="7" ry="2.2" />
                <rect
                  class="pkg-box"
                  x="-7"
                  y="-5"
                  width="14"
                  height="11"
                  rx="1.5"
                />
                <path class="pkg-ribbon" d="M0 -5v11M-7 -1h14" />
              </g>
            </svg>

            {/* <!-- carrier logos --> */}
            <div class="ship-carrier ship-carrier-dhl">
              <img
                src="assets/images/carrier_logo/dhl.webp"
                alt="DHL"
                loading="lazy"
              />
            </div>
            <div class="ship-carrier ship-carrier-fedex">
              <img
                src="assets/images/carrier_logo/fedex.webp"
                alt="FedEx"
                loading="lazy"
              />
            </div>
            <div class="ship-carrier ship-carrier-ups">
              <img
                src="assets/images/carrier_logo/ups.webp"
                alt="UPS"
                loading="lazy"
              />
            </div>
            <div class="ship-carrier ship-carrier-amazon">
              <img
                src="assets/images/carrier_logo/amazon.webp"
                alt="Amazon"
                loading="lazy"
              />
            </div>

            {/* <!-- live tracking card --> */}
            <div class="ship-track" id="shipTrack">
              <div class="ship-track-head">
                <span class="ship-live">
                  <span class="ship-live-dot"></span> Live Tracking
                </span>
                <span class="ship-track-badge" id="trackBadge">
                  PICKUP
                </span>
              </div>
              <div class="ship-track-row">
                <span class="ship-track-ico">
                  <i class="bi bi-box-seam"></i>
                </span>
                <div class="ship-track-txt">
                  <b id="trackStatus">Pickup scheduled</b>
                  <span id="trackMeta">
                    SKY-24918 &middot; Hyderabad &rarr; Mumbai
                  </span>
                </div>
              </div>
              <div class="ship-track-bar">
                <span id="trackBar"></span>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Auth_brand;
